export enum CursorType {
  Pointer = 'pointer',
  Default = 'default',
  Move = 'move',
  Text = 'text',
  NotAllowed = 'not-allowed',
  Grab = 'grab',
}
